import { useParams } from 'react-router-dom'

import { TrainingMaterialsFileViewerDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { File, FileViewer } from 'modules/trainings/components/Files/FileViewer'

export default function TrainingMaterialsFileViewer() {
  const { id, fileId } = useParams<{
    id: string
    fileId: string
  }>()
  const { navigation } = useNavigation()
  const { data, loading } = useQuery(TrainingMaterialsFileViewerDocument, {
    variables: { trainingId: Number(id) },
  })

  const files: File[] =
    data?.trainings?.trainingFilesConnection?.nodes
      .map((file) => ({
        id: file.id,
        filename: file.filename,
        title: file.title,
        fileUrl: file.url,
        contentType: file.contentType,
        url: file.url,
        type: 'training' as const,
      }))
      .sort((a, b) => ((a.title || a.filename) > (b.title || b.filename) ? 1 : -1)) ?? []

  if (loading) return null

  return (
    <FileViewer
      files={files}
      file={files.find((f) => f.id === Number(fileId))}
      urlBackTo={navigation.trainings.list.details_revamp.view.attachments.fullPath({
        id: String(id),
      })}
      goNextFile={(f) =>
        navigation.trainings.list.details_revamp.view.attachments.previewFile.fullPath({
          id: String(id),
          fileId: f.id,
        })
      }
      goPrevFile={(f) =>
        navigation.trainings.list.details_revamp.view.attachments.previewFile.fullPath({
          id: String(id),
          fileId: f.id,
        })
      }
    />
  )
}
